<template>
    <div class="bn-domain-search">
    </div>
</template>

<script>

  import employees from 'assets/data/about/employees.json'
  import style from 'styles/about.scss'

  export default {
    name: 'domains_search',
    data () {
        return {}
    },
    mounted() {
          $('.bn-domain-search').bnDomSearch({
            'api_uri': 'https://api-v2-staging.bravenet.com',
            'checkout_url': 'https://www.bravenet.com/login',
            'root_path': '/domains_search/',
            'cart_hash': 'random',
            "migrate_user": true,
            "trigger_doc_ready": true
          });

    }
  }
</script>




// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/domains_search.vue